import {connect} from 'react-redux';
import * as React from "react";
import GroupAdminState, {ContractGroup, Contract} from "../GroupAdminState";
import * as selectors from "../selectors";
import {
    removeContractFromGroup,
    RemoveContractFromGroup
} from "../actions";


interface ComponentState {
}

interface TagProps {

}

interface StateProps {
    selectedContractGroup: ContractGroup,
}

interface DispatchProps {
    doRemoveContract: RemoveContractFromGroup;
}

const mapStateToProps = (state: GroupAdminState): StateProps => {
    return {
        selectedContractGroup: selectors.selectedContractGroup(state),
    };
};

const mapDispatchToProps = ({
    doRemoveContract: removeContractFromGroup,
});

type Props = TagProps & StateProps & DispatchProps;

class ContractManagerComponent extends React.Component<Props, ComponentState> {
    render() {

        let {selectedContractGroup} = this.props;

        if (!selectedContractGroup) return (
            <p>Velg en kontraktgruppe</p>
        );

        return (
            <div id="contract-manager">

                <div className="contract-manager-head">
                    <h2>Kontrakter</h2>
                </div>

                <ContractList contracts={selectedContractGroup.contracts} handleRemoveContract={this.handleRemoveContract}/>

            </div>
        )
    }

    handleRemoveContract = function (contractId: string) {
        this.props.doRemoveContract(contractId, this.props.selectedContractGroup.id);
    }.bind(this)

}

type CompareType = (a:ContractGroup, b:ContractGroup) => number;

const compareContractNames = (intlCollator:Intl.Collator):CompareType => {
    return function compareWithIntlCollator (a:Contract, b:Contract):number {
        return intlCollator.compare(a.name, b.name);
    }
}

const sortContracts = (contracts: Contract[], intlCollator:Intl.Collator):Contract[] => {
    // Sorts contracts inplace
    contracts.sort(compareContractNames(intlCollator));
    return contracts;
}

interface ContractListProps {
    contracts: Contract[];
    handleRemoveContract: (id: string) => void;
}

const ContractList = ({contracts, handleRemoveContract}: ContractListProps) => {

    if (contracts.length === 0) {
        return (
            <p className="infobox">
                Ingen kontrakter i denne gruppen
            </p>
        )
    }
    
    let intlCollator = Intl.Collator('nb', { numeric: true });

    return (
        <ul className="contract-manager-list">
            {sortContracts(contracts, intlCollator).map(contract => {
                return (
                    <li className="cml--element" key={contract.id}>
                        <div className="cml--content">
                            <h4>{contract.name}</h4>
                        </div>
                        <div className="cml--tools">
                            <button onClick={() => handleRemoveContract(contract.id)}>Fjern</button>
                        </div>
                    </li>
                )
            })}
        </ul>

    )
}

export const ContractManager = connect(mapStateToProps, mapDispatchToProps)(ContractManagerComponent);

